import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';
import { Link } from '@comparethemarketau/manor-link';

const useStyles = createUseStyles((theme) => ({
    container: {
    }

}));

const FindInsurerNotice = ({ className }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classNames('test-emptyState-findInsurerNotice', classes.container, className)}>
            <Typography component="span" className={classes.text}>
                {
                    "You may want to refer to the Insurer Council of Austalia's \"Find an Insurer\" website at  "
                }
                <Typography display={'inline'}>
                    <Link
                        underline="none"
                        target="_blank"
                        trackingLabel="link for http://www.findinsurer.com.au/"
                        href="http://www.findinsurer.com.au/"
                    >
                        {'www.findinsurer.com.au'}
                    </Link>
                </Typography>
                {
                    ' and they may be able to provide you with a list of companies who can assist you with cover.'
                }
            </Typography>

        </div>
    );
};

FindInsurerNotice.propTypes = {
    className: PropTypes.string
};

export { FindInsurerNotice };
